import React from "react";
import styles from "../../screens/Homepage/style.module.scss";
import images from "../../../core/constants/images";

const PortofolioPart = () => {
  return (
    <div
      style={{ backgroundImage: `url(${images.portofolioBannerMobile})` }}
      className={styles.portofolioBanner}
    >
      <div className={styles.honeycombContainer}>
        <div className={styles.firstHoneycombRow}>
          <div className={styles.diamondShape}>
            <img src={images.dogScoutsLogo} className={styles.honeycombImage} />
          </div>
        </div>
        <div className={styles.secondHoneycombRow}>
          <div className={styles.diamondShape}>
            <img
              src={images.chalkNotesLogo}
              className={styles.honeycombImage}
            />
          </div>
          <div className={styles.diamondShape}>
            <img
              src={images.romanticStudioLogo}
              className={styles.honeycombImage}
            />
          </div>
        </div>
        <div className={styles.thirdHoneycombRow}>
          <div className={styles.diamondShape}>
            <img
              style={{ width: "80%", height: "auto" }}
              src={images.izibacLogo}
              className={styles.honeycombImage}
            />
          </div>
          <div className={styles.diamondShape}>
            <img
              src={images.casaCerbuluiLogo}
              className={styles.honeycombImage}
              style={{ width: "100%", height: "auto" }}
            />
          </div>
          <div className={styles.diamondShape}>
            <img
              src={images.zemLogo}
              className={styles.honeycombImage}
              style={{ width: "100%", height: "auto" }}
            />
          </div>
        </div>
        <div className={styles.secondHoneycombRow}>
          <div className={styles.diamondShape}>
            <img
              src={images.oasisLogo}
              className={styles.honeycombImage}
              style={{ height: "13%" }}
            />
          </div>
          <div className={styles.diamondShape}>
            <img src={images.bookTradeLogo} className={styles.honeycombImage} />
          </div>
        </div>
        <div className={styles.lastHoneycombRow}>
          <div className={styles.diamondShape}>
            <img
              src={images.bsrLogo}
              className={styles.honeycombImage}
              style={{ height: "35%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortofolioPart;
